import {
  ApplicationUserCrudClient,
  DealLender,
  DealLenderMessageClient,
  FeedBack,
  UserClient,
} from "@src/apis/ModularClient";
import { RoleService } from "@js/services/RoleService";
import { IndexService } from "@js/services/IndexService";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class BaseHeadsOfTermsController {
  isLender: boolean = false;
  isBroker: boolean = false;
  isAdmin: boolean = false;
  isClient: boolean = false;
  currentCaseLender: DealLender;
  dataLoading: boolean = false; // Controls showing the data loading "spinner"
  currentUser: { email: string; phoneNumber: string; fullName: string; id: number; isConnectUser: boolean };
  toggleFeedbackSection: boolean = false;
  feedBackDTO: FeedBack = {
    feedbackText: "",
    responseText: "",
  } as FeedBack;
  static $inject = [
    "$rootScope",
    "UserClient",
    "RoleService",
    "DealLenderMessageClient",
    "ApplicationUserCrudClient",
    "IndexService",
    "ODataHelper",
  ];
  constructor(
    protected $routeParams: ng.route.IRouteParamsService,
    protected userClient: UserClient,
    protected roleService: RoleService,
    protected dealLenderMessageClient: DealLenderMessageClient,
    protected applicationUserCrudClient: ApplicationUserCrudClient,
    protected indexService: IndexService,
    protected oDataHelper: ODataHelper,
  ) {}
  populateLenderInformation(lenderInfo: { email: string; phoneNumber: string; fullName: string }) {
    if (this.isLender) {
      this.currentCaseLender.contactName = lenderInfo.fullName;
      this.currentCaseLender.contactEmail = lenderInfo.email;
      this.currentCaseLender.contactMobilePhoneNumber = lenderInfo.phoneNumber;
    }
  }

  async getCurrentUserAndRoles() {
    this.dataLoading = true;

    const userId = await this.indexService.currentUserId;

    this.oDataHelper
      .getOne(this.applicationUserCrudClient, {
        filter: { id: { eq: userId } },
        select: {
          id: true,
          email: true,
          phoneNumber: true,
          fullName: true,
          isConnectUser: true,
        },
      })
      .then((result) => {
        this.currentUser = result;

        return Promise.all([
          this.roleService.isClientUser(),
          this.roleService.isAdminUser(),
          this.roleService.isBroker(),
          this.roleService.isLenderUser(),
        ]);
      })
      .then(([isClient, isAdmin, isBroker, isLender]) => {
        this.isClient = isClient;
        this.isAdmin = isAdmin;
        this.isBroker = isBroker;
        this.isLender = isLender;

        if (!this.isLender) {
          this.toggleFeedbackSection = true;
          this.updateCaseLenderMessageReadDatetime();
        }
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  updateCaseLenderMessageReadDatetime() {
    this.dealLenderMessageClient.updateDealLenderMessageReadDatetime(this.$routeParams.DealLenderId).then(() => {});
  }
}
